<div class="left-nav">
    <nz-switch [ngModel]="collapsed" (ngModelChange)="toggleCollapsed()"></nz-switch>
    <sidebar-nav class="d-block mt-md"></sidebar-nav>
</div>
